import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

export default function useVisitorTracking() {
  const location = useLocation();

  useEffect(() => {
    const isAdmin = location.pathname.startsWith("/admin");
    if (isAdmin) return;

    const timeout = setTimeout(() => {
      api.trackVisitor({
        page_path: `${location.pathname}${location.search}`,
        page_title: document.title,
        referrer: document.referrer || "Direct / unknown",
        screen_width: window.screen?.width,
        screen_height: window.screen?.height,
        language: navigator.language || "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      }).catch(() => {});
    }, 600);

    return () => clearTimeout(timeout);
  }, [location.pathname, location.search]);
}